export default "__VITE_ASSET__CoC_PtGl__"